import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Detecta el idioma automáticamente
  .use(LanguageDetector)
  // Carga las traducciones usando http -> ver /public/locales
  // aprende más: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // Pasa la instancia i18n a react-i18next.
  .use(initReactI18next)
  // Inicializa i18next
  // para todas las opciones lee: https://www.i18next.com/overview/configuration-options
  .init({
    // Idioma por defecto
    fallbackLng: 'es',
    // Idiomas soportados
    supportedLngs: ['es', 'en'],
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // No necesario para react ya que escapa por defecto
    },

    // Configuración del backend
    backend: {
      // Ruta donde están los archivos de traducción
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Configuración del detector de idioma
    detection: {
      // Opciones disponibles: localStorage, sessionStorage, navigator, querystring, cookie, subdomain, path
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Cache en localStorage
      caches: ['localStorage'],
    },

    // Recursos para cargar
    ns: ['common'],
    defaultNS: 'common',
  });

export default i18n;